/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics Calculator (Mean, Median, Mode, Std Dev) — Toolverse`)
};

const es_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Estadística (Media, Mediana, Moda, Desv. Estándar) — Toolverse`)
};

const de_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistik-Rechner (Mittelwert, Median, Modus, Standardabweichung) — Toolverse`)
};

const nl_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiek Calculator (Gemiddelde, Mediaan, Modus, Std.afw.) — Toolverse`)
};

const fr_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de Statistiques (Moyenne, Médiane, Mode, Écart-Type) — Toolverse`)
};

const it_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di statistica (media, mediana, moda, deviazione standard) — Toolverse`)
};

const pt_br2_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Estatística (Média, Mediana, Moda, Desvio Padrão) — Toolverse`)
};

const pt_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Estatística (Média, Mediana, Moda, Desvio-Padrão) — Toolverse`)
};

const ja_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統計計算機(平均値・中央値・最頻値・標準偏差) — Toolverse`)
};

const zh_st_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计计算器（平均数、中位数、众数、标准差）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_meta_title", locale)
	if (locale === "en") return en_st_meta_title(inputs)
	if (locale === "es") return es_st_meta_title(inputs)
	if (locale === "de") return de_st_meta_title(inputs)
	if (locale === "nl") return nl_st_meta_title(inputs)
	if (locale === "fr") return fr_st_meta_title(inputs)
	if (locale === "it") return it_st_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_st_meta_title(inputs)
	if (locale === "pt") return pt_st_meta_title(inputs)
	if (locale === "ja") return ja_st_meta_title(inputs)
	return zh_st_meta_title(inputs)
};